/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFAQ = {
  init() {
    const $faqHeading = $('.faq-accordion > div > dt > button');
    const $faqContent = $('.faq-accordion > div > dd');

    // Set accessibility attributes and hide all content initially
    $faqContent.attr('aria-hidden', true).hide();
    $faqHeading.attr('aria-expanded', false);

    // Default state: Open the first accordion item
    const $firstHeading = $faqHeading.first();
    const $firstContent = $faqContent.first();

    if ($firstHeading.length) {
      $firstHeading.attr('aria-expanded', true);
      $firstHeading.find('.icon').addClass('icon--active');
      $firstContent.attr('aria-hidden', false).show();
    }

    // Handle Click/Activate events
    $faqHeading.off('click activate').on('click activate', function (e) {
      e.preventDefault();
      const faqIcons = $(this).find('.icon');
      const isExpanded = $(this).attr('aria-expanded') === 'true';
      const newState = !isExpanded;

      // Update current button state
      $(this).attr('aria-expanded', newState);
      
      // Toggle the associated content (dd)
      $(this).parent().next().slideToggle(400, () => {
        // Toggle the active class for the icon after animation
        faqIcons.toggleClass('icon--active', newState);
      });

      // Update accessibility for content
      $(this).parent().next().attr('aria-hidden', !newState);
      
      return false;
    });

    // Handle Keyboard events (Enter key)
    $faqHeading.on('keydown', function (event) {
      const keyCode = event.keyCode || event.which;
      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
  },
  unload() {
    $('.faq-accordion > div > dt > button').off('click activate keydown');
  },
};

/******/ })()
;